
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

const CasesSection: React.FC = () => {
  const { t } = useTranslation();
  const [activeCategory, setActiveCategory] = useState('all');

  const categories = [
    { id: 'all', name: t('cases.categories.all') },
    { id: '网站', name: t('cases.categories.web') },
    { id: '小程序', name: t('cases.categories.mini') },
    { id: 'APP', name: t('cases.categories.app') },
    { id: '区块链', name: t('cases.categories.blockchain') },
    { id: '技术迁移', name: t('cases.categories.migration') },
    { id: 'AI系统', name: t('cases.categories.ai') }
  ];

  const cases = [
    {
      id: 1,
      title: t('cases.items.1.title'),
      category: 'AI系统',
      description: t('cases.items.1.desc'),
      image: 'https://readdy.ai/api/search-image?query=Modern%20AI%20dashboard%20interface%20with%20chat%20bot%20assistant%2C%20data%20visualization%20charts%20and%20graphs%2C%20clean%20blue%20and%20white%20design%2C%20professional%20business%20analytics%20platform%2C%20conversational%20AI%20interface%2C%20real-time%20data%20monitoring&width=400&height=300&seq=ai-dashboard&orientation=landscape',
      tech: ['React', 'Node.js', 'AI/ML', 'Chart.js'],
      stats: { users: '5000+', performance: '4.9分', time: '4个月' }
    },
    {
      id: 2,
      title: t('cases.items.2.title'),
      category: '小程序',
      description: t('cases.items.2.desc'),
      image: 'https://readdy.ai/api/search-image?query=Modern%20e-commerce%20mobile%20app%20interface%20showing%20product%20catalog%2C%20shopping%20cart%2C%20payment%20system%2C%20clean%20minimalist%20design%20with%20soft%20colors%2C%20professional%20mobile%20commerce%20platform&width=400&height=300&seq=ecommerce-mini&orientation=landscape',
      tech: ['微信小程序', 'Node.js', 'MySQL', '微信支付'],
      stats: { users: '10万+', performance: '4.8分', time: '3个月' }
    },
    {
      id: 3,
      title: t('cases.items.3.title'),
      category: '网站',
      description: t('cases.items.3.desc'),
      image: 'https://readdy.ai/api/search-image?query=Professional%20corporate%20website%20homepage%20with%20modern%20design%2C%20responsive%20layout%2C%20clean%20typography%2C%20business%20presentation%2C%20elegant%20color%20scheme%2C%20professional%20web%20design&width=400&height=300&seq=corporate-web&orientation=landscape',
      tech: ['React', 'TypeScript', 'Tailwind CSS', 'Next.js'],
      stats: { users: '2万+', performance: '4.9分', time: '2个月' }
    },
    {
      id: 4,
      title: t('cases.items.4.title'),
      category: '区块链',
      description: t('cases.items.4.desc'),
      image: 'https://readdy.ai/api/search-image?query=NFT%20digital%20collectibles%20marketplace%20interface%2C%20blockchain%20art%20gallery%2C%20crypto%20wallet%20integration%2C%20modern%20dark%20theme%20design%2C%20digital%20art%20showcase%20platform&width=400&height=300&seq=nft-platform&orientation=landscape',
      tech: ['React', 'Web3.js', 'Solidity', 'IPFS'],
      stats: { users: '3万+', performance: '4.7分', time: '6个月' }
    },
    {
      id: 5,
      title: t('cases.items.5.title'),
      category: 'APP',
      description: t('cases.items.5.desc'),
      image: 'https://readdy.ai/api/search-image?query=Mobile%20office%20application%20interface%2C%20business%20productivity%20app%2C%20clean%20professional%20design%2C%20task%20management%2C%20team%20collaboration%20features%2C%20modern%20mobile%20UI&width=400&height=300&seq=office-app&orientation=landscape',
      tech: ['React Native', 'Redux', 'Node.js', 'MongoDB'],
      stats: { users: '5万+', performance: '4.6分', time: '5个月' }
    },
    {
      id: 6,
      title: t('cases.items.6.title'),
      category: '区块链',
      description: t('cases.items.6.desc'),
      image: 'https://readdy.ai/api/search-image?query=DeFi%20liquidity%20mining%20platform%20interface%2C%20cryptocurrency%20trading%20dashboard%2C%20blockchain%20finance%20application%2C%20modern%20fintech%20design%2C%20yield%20farming%20interface&width=400&height=300&seq=defi-platform&orientation=landscape',
      tech: ['Vue.js', 'Web3.js', 'Solidity', 'Ethereum'],
      stats: { users: '1.5万+', performance: '4.8分', time: '8个月' }
    },
    {
      id: 7,
      title: t('cases.items.7.title'),
      category: '网站',
      description: t('cases.items.7.desc'),
      image: 'https://readdy.ai/api/search-image?query=Online%20education%20platform%20interface%2C%20e-learning%20website%2C%20video%20streaming%2C%20course%20management%2C%20student%20dashboard%2C%20modern%20educational%20technology%20design&width=400&height=300&seq=education-platform&orientation=landscape',
      tech: ['Vue.js', 'Laravel', 'MySQL', 'WebRTC'],
      stats: { users: '8万+', performance: '4.7分', time: '6个月' }
    },
    {
      id: 8,
      title: t('cases.items.8.title'),
      category: '区块链',
      description: t('cases.items.8.desc'),
      image: 'https://readdy.ai/api/search-image?query=Blockchain%20supply%20chain%20tracking%20interface%2C%20product%20traceability%20system%2C%20logistics%20management%20dashboard%2C%20industrial%20technology%20platform%2C%20transparent%20supply%20chain%20visualization&width=400&height=300&seq=supply-chain&orientation=landscape',
      tech: ['React', 'Hyperledger', 'Node.js', 'PostgreSQL'],
      stats: { users: '200+企业', performance: '4.9分', time: '10个月' }
    },
    {
      id: 9,
      title: t('cases.items.9.title'),
      category: '小程序',
      description: t('cases.items.9.desc'),
      image: 'https://readdy.ai/api/search-image?query=AI%20customer%20service%20chat%20interface%2C%20intelligent%20chatbot%20application%2C%20customer%20support%20system%2C%20modern%20messaging%20design%2C%20automated%20customer%20service%20platform&width=400&height=300&seq=ai-customer-service&orientation=landscape',
      tech: ['微信小程序', 'AI/NLP', 'Python', 'Redis'],
      stats: { users: '12万+', performance: '4.8分', time: '4个月' }
    },
    {
      id: 10,
      title: t('cases.items.10.title'),
      category: '区块链',
      description: t('cases.items.10.desc'),
      image: 'https://readdy.ai/api/search-image?query=Smart%20contract%20audit%20platform%20interface%2C%20blockchain%20security%20analysis%2C%20code%20review%20dashboard%2C%20cybersecurity%20tools%2C%20professional%20audit%20system%20design&width=400&height=300&seq=contract-audit&orientation=landscape',
      tech: ['React', 'Python', 'Solidity', 'Docker'],
      stats: { users: '500+项目', performance: '4.9分', time: '7个月' }
    },
    {
      id: 11,
      title: t('cases.items.11.title'),
      category: '技术迁移',
      description: t('cases.items.11.desc'),
      image: 'https://readdy.ai/api/search-image?query=System%20migration%20visualization%2C%20PHP%20to%20Go%20language%20transition%2C%20performance%20optimization%20charts%2C%20technical%20architecture%20diagram%2C%20modern%20software%20development&width=400&height=300&seq=php-go-migration&orientation=landscape',
      tech: ['Go', 'PHP', 'Docker', 'Kubernetes'],
      stats: { users: '性能提升300%', performance: '5.0分', time: '12个月' }
    },
    {
      id: 12,
      title: t('cases.items.12.title'),
      category: 'AI系统',
      description: t('cases.items.12.desc'),
      image: 'https://readdy.ai/api/search-image?query=Data%20analytics%20visualization%20platform%2C%20AI-powered%20business%20intelligence%20dashboard%2C%20interactive%20charts%20and%20graphs%2C%20conversational%20data%20analysis%2C%20modern%20BI%20interface&width=400&height=300&seq=data-analytics&orientation=landscape',
      tech: ['React', 'Python', 'TensorFlow', 'D3.js'],
      stats: { users: '1000+企业', performance: '4.8分', time: '8个月' }
    }
  ];

  const filteredCases = activeCategory === 'all' 
    ? cases 
    : cases.filter(case_ => case_.category === activeCategory);

  return (
    <section id="cases" className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            {t('cases.title')}
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t('cases.intro')}
          </p>
        </div>

        {/* Category Filter */}
        <div className="flex flex-wrap justify-center gap-4 mb-12">
          {categories.map((category) => (
            <button
              key={category.id}
              onClick={() => setActiveCategory(category.id)}
              className={`px-6 py-3 rounded-full font-medium transition-all duration-300 cursor-pointer whitespace-nowrap ${
                activeCategory === category.id
                  ? 'bg-blue-600 text-white shadow-lg'
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
              }`}
            >
              {category.name}
            </button>
          ))}
        </div>

        {/* Cases Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {filteredCases.map((case_) => (
            <div 
              key={case_.id}
              className="bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden group"
            >
              <div className="relative h-48 overflow-hidden">
                <img 
                  src={case_.image}
                  alt={case_.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              </div>
              
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-2">
                  {case_.title}
                </h3>
                <p className="text-gray-600 mb-4 text-sm leading-relaxed">
                  {case_.description}
                </p>
                
                {/* Tags */}
                <div className="flex flex-wrap gap-2 mb-4">
                  {case_.tech.map((tag, index) => (
                    <span 
                      key={index}
                      className="px-3 py-1 bg-blue-100 text-blue-600 text-xs rounded-full"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
                
                {/* Stats */}
                <div className="grid grid-cols-3 gap-4 pt-4 border-t border-gray-100">
                  <div className="text-center">
                    <p className="text-lg font-bold text-blue-600">{case_.stats.users}</p>
                    <p className="text-xs text-gray-500">{t('cases.stat.users')}</p>
                  </div>
                  <div className="text-center">
                    <p className="text-lg font-bold text-green-600">{case_.stats.performance}</p>
                    <p className="text-xs text-gray-500">{t('cases.stat.rating')}</p>
                  </div>
                  <div className="text-center">
                    <p className="text-lg font-bold text-purple-600">{case_.stats.time}</p>
                    <p className="text-xs text-gray-500">{t('cases.stat.duration')}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CasesSection;
